export default __webpack_public_path__ + "static/media/mrLogo.0b1b3334.png";